import { createAction, props } from "@ngrx/store";
import { StudentDto } from "../interfaces/student_dto";
import { StudentAddRequest } from "../interfaces/student_add_request";
import { StudentUpdateRequest } from "../interfaces/student_update_request";
import { FileObject } from "@supabase/storage-js";
import { FileInfo } from "src/app/supabase/interfaces/FileInfo";

export const loadStudents = createAction(
    "[Students] Load Students"
);

export const loadStudentsSuccess = createAction(
    "[Students] Load Students Success",
    props<{ students: StudentDto[] }>()
);

export const selectStudent = createAction(
    "[Students] Select Student",
    props<{ student: StudentDto }>()
);

export const loadStudent = createAction(
    "[Students] Load Student",
    props<{ studentId: number }>()
);

export const loadStudentSuccess = createAction(
    "[Students] Load Student Success",
    props<{ student: StudentDto }>()
);

export const addStudent = createAction(
    "[Students] Add Student",
    props<{ student: StudentAddRequest, profile_picture?: string, attachments?: File[] }>()
);

export const addStudentSuccess = createAction(
    "[Students] Add Student Success",
    props<{ student: StudentDto }>()
);

export const updateStudent = createAction(
    "[Students] Update Student",
    props<{ student: Partial<StudentUpdateRequest>, profile_picture?: string, attachments?: File[] }>()
)

export const updateStudentSuccess = createAction(
    "[Students] Update Student Success",
    props<{ student: StudentDto }>()
);


export const deleteStudent = createAction(
    "[Students] Delete Student",
    props<{ student: StudentDto }>()
);

export const deleteStudentSuccess = createAction(
    "[Students] Delete Student Success",
    props<{ student: StudentDto }>()
);

export const upsertStudents = createAction(
    "[Students] Upsert Students",
    props<{ students: StudentDto[] }>()
);

export const uploadFiles = createAction(
    "[Students] Upload Files",
    props<{ files: File[] }>()
)

export const downloadAttachment = createAction(
    "[Students] Open Attachment",
    props<{ container: string, fileName: string, attachmentFileInfo: FileInfo }>()
)

export const openAttachment = createAction(
    "[Students] Open Attachment Success",
    props<{ fileName: string, file: Blob }>()
)

export const openAttachmentSuccess = createAction(
    "[Students] Open Attachment Success"
)

export const openAttachmentFailed = createAction(
    "[Students] Open Attachment Failed"
)

export const deleteAttachment = createAction(
    "[Students] Delete Attachment",
    props<{ student: StudentDto, attachment: string }>()
)

export const deleteAttachmentSuccess = createAction(
    "[Students] Delete Attachment Success",
    props<{ student: StudentDto, attachment: string }>()
)
